<template>
  <overlay-scrollbars id="katalog-scroll-container"
                      :options="{ className: 'content white custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <TheLoader :active="loading || updating" :update="updating"/>
    <section class="content fixed-width small scrollnav" style="padding: 15px 0 0 15px">
      <TheSelectInput v-model="year" containerClassName="cell medium-6 large-6" label="Select a Year" name="Avdelingsid" :items="years" @input="resetAndReload"/>
    </section>
    <section class="content large white">
      <table class="large fixed visible sticky-table-header compressed sortable" style="width: 100%">
        <thead>
        <tr>
          <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === sortKey ? sortClass : '']" @click="sortBy(heading.sortKey)">
            {{heading.name}}
            <span id="sorttable_sortrevind" v-if="heading.sortKey === sortKey && !reverse">&nbsp;</span>
            <span id="sorttable_sortfwdind" v-if="heading.sortKey === sortKey && reverse">&nbsp;</span>
          </th>
        </tr>
        </thead>
        <tbody v-if="!loading && items.length < 1">
        <tr>
          <td colspan="7">
            <em>Fant ingen kunder...</em>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr v-for="item in items" v-bind:key="item.id">
          <td><a :href="'/kunde/' + item.Kundenr">{{ item.Kundenr }}</a></td>
          <td>{{ item.full_name }}</td>
          <td>{{ item.Email }}</td>
          <td v-html="formatValue(item.sum_objekt_seller_tilslag)"></td>
          <td v-html="formatValue(item.sum_objekt_buyer_tilslag)"></td>
          <td v-html="formatDateMoment(item.kyc_exceeded)"></td>
          <td>{{ item.kyc_sent == 1 ? 'Yes' : 'No'}}</td>
          <td v-html="formatDateMoment(item.kyc_filled)"></td>
          <td><a href="javascript:;" @click="openKundeModal(item.Kundenr)">Edit KYC data</a></td>
        </tr>
        </tbody>
      </table>
      <br>
      <br>
      <div class="pagination-container" v-if="pages > 1" style="margin-top: -1rem;">
        <paginate v-model="params.page"
                  :page-count="pages"
                  :page-range="11"
                  :click-handler="setPage"
                  :container-class="'pagination'"
                  :prev-text="paginationArrow"
                  :next-text="paginationArrow"
                  :prev-class="'prev'"
                  :next-class="'next'"
        >
        </paginate>
      </div>
    </section>
  </overlay-scrollbars>
</template>

<script>

import KundeService from '@/services/KundeService'
import bus from '@/plugins/event-bus'
import moment from 'moment'
import accounting from 'accounting-js'

export default {
  name: 'KnowYourCustomerList',
  data () {
    return {
      loading: false,
      updating: false,
      items: [],
      pages: 1,
      params: null,
      year: new Date().getFullYear(),
      years: [],
      selected: [],
      headings: [
        {name: 'Kundenr', sortKey: 'Kundenr', class: ''},
        {name: 'Kunde Navn', sortKey: 'full_name', class: ''},
        {name: 'Kunde Email', sortKey: 'Email', class: ''},
        {name: 'Seller amount', sortKey: 'sum_objekt_seller_tilslag', class: ''},
        {name: 'Buyer amount', sortKey: 'sum_objekt_buyer_tilslag', class: ''},
        {name: 'KYC exceeded', sortKey: 'kyc_exceeded', class: ''},
        {name: 'KYC sent', sortKey: 'kyc_sent', class: ''},
        {name: 'KYC filled', sortKey: 'kyc_filled', class: ''},
        {name: 'Edit', sortKey: '', class: ''}
      ],
      sortKey: 'kyc_sent',
      reverse: true
    }
  },
  created () {
    bus.$off('reload-kataloglist')
    bus.$off('reflesh-kataloglist')
    this.generateYears()
  },
  mounted () {
    bus.$on('reload-kataloglist', () => this.resetAndReload())
    bus.$on('reflesh-kataloglist', () => this.refleshPage())
  },
  activated () {
    this.loading = true
    this.setDefaultParams()
    this.fetch()
  },
  computed: {
    sortClass: function () {
      return 'sorttable_sorted' + (this.reverse ? '_reverse' : '')
    }
  },
  methods: {
    generateYears () {
      const currentYear = new Date().getFullYear()
      for (let i = 0; i < 5; i++) {
        this.years.push({
          'key': currentYear - i,
          'val': currentYear - i
        })
      }
    },
    setDefaultParams: function () {
      this.params = {
        page: 1,
        limit: 50,
        sort: 'kyc_sent',
        direction: 'ASC',
        year: this.year
      }
    },
    resetAndReload: function () {
      this.updating = true
      this.$emit('onSubmitStatusChange', 'loading')
      this.setDefaultParams()
      this.fetch()
    },
    refleshPage: function () {
      this.updating = true
      this.$emit('onSubmitStatusChange', 'loading')
      this.fetch()
    },
    setPage: function (page) {
      let vm = this

      window.jQuery('.os-viewport', window.jQuery('#katalog-scroll-container')).animate({
        scrollTop: 0
      }, 200, function () {
        vm.updating = true
        vm.$emit('onSubmitStatusChange', 'loading')
        vm.fetch()
      })
    },
    sortBy: function (sortKey) {
      if (!sortKey) return
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
      this.sortKey = sortKey

      this.loading = true
      this.updating = true

      this.params.sort = sortKey
      this.params.direction = this.reverse ? 'ASC' : 'DESC'
      this.fetch()
    },
    fetch: function () {
      this.selected = []

      KundeService.getKnowYourCustomerList(this.params)
        .then((response) => {
          if (response.data.length === 0) {
            this.pages = 0
            this.items = []
          } else {
            this.pages = parseInt(response.data[0].total)
            this.items = response.data
          }
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    },
    formatDateMoment: function (date) {
      if (date) {
        let momentObj = moment(date, 'YYYY-MM-DD HH:mm:ss')
        return momentObj.format('DD.MM.YYYY')
      } else {
        return '---'
      }
    },
    formatValue: function (value) {
      if (value !== undefined && value !== null && value !== '') {
        return accounting.formatNumber(value, {precision: 0, thousand: ' '})
      }
      return '0'
    },
    openKundeModal: function (kundenr) {
      this.openModal(
        'kunde-kyc-modal',
        {
          kundeId: parseInt(kundenr),
          event: 'reflesh-kataloglist'
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/KnowYourCustomerList.vue